import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';
import { DepositPaymentStatesEnum } from '../document-data.data';

export const DEPOSIT_PAYMENT_SCHEMA = Object.freeze({
  PERCENTAGE: 0.0,
  TOTAL_AMOUNT: 0,
  AMOUNT_PAID: 0,
  AMOUNT_REMAINING: 0,
  STATE: DepositPaymentStatesEnum.unpaid,
});
export const RECORD = generateSchema(DEPOSIT_PAYMENT_SCHEMA);
export const KEYS: any = generateKeys(DEPOSIT_PAYMENT_SCHEMA);

export class DepositPayment extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get state(): DepositPaymentStatesEnum {
    return this.get(KEYS.STATE);
  }

  get totalAmount(): number {
    return this.get(KEYS.TOTAL_AMOUNT);
  }

  get amountPaid(): number {
    return this.get(KEYS.AMOUNT_PAID);
  }

  get amountRemaining(): number {
    return this.get(KEYS.AMOUNT_REMAINING);
  }

  get percentage(): number {
    return this.get(KEYS.PERCENTAGE);
  }

  isUnpaid(): boolean {
    return this.state === DepositPaymentStatesEnum.unpaid;
  }
}
